import LibraryResourceContainer from "library/show/components/LibraryResourceContainer"
import path from "path-browserify"
import MessageContainer from "./components/MessageContainer"
import { clearMessageContext, loadMessageContext } from "./middleware"

const getDefaultLaunchedFrom = ({ location }) => {
  path.join(location.pathname, "../../")
}

export default {
  path: "/library/:resourceSlug/:cohortId(\\d+)/:section/message/",
  onEnter: loadMessageContext,
  onLeave: clearMessageContext,
  getDefaultLaunchedFrom: getDefaultLaunchedFrom,
  components: {
    modal: MessageContainer,
    primary: LibraryResourceContainer
  }
}
